module.exports = __webpack_public_path__ + "static/media/go-cowboys.46aefd3a.jpg";